<template>
  <el-container>
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>添加留言系统管理员</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-star-on" @click.native="rolesSave()">
          添 加
        </el-button>
        <el-button type="info" icon="el-icon-return" @click.native="formReturn()">
          返 回
        </el-button>
      </el-button-group>
    </el-header>
    <el-main>
      <el-form label-width="100px">
        <el-form-item label="姓名搜索">
          <el-input suffix-icon="el-icon-search" v-model="query.name" placeholder="输入姓名或部分"
            @input="queryEmps"></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="data.emps" style="width: 100%" ref="EmpTable">
        <el-table-column type="selection" width="50" :selectable="selectable" />
        <el-table-column align="left" property="name" label="姓名" width="100px" />
        <el-table-column align="left" property="phone" label="电话" width="150px" />
        <el-table-column align="left" property="unitName" label="单位" />
        <el-table-column align="left" property="hasRoles.roles" label="角色" />
        <el-table-column align="left" property="officeName" label="成员类别" />
      </el-table>
      <el-pagination layout="prev,pager, next" :total="xpagination.totalCount" :page-size="xpagination.pageSize"
        @current-change="handleCurrentChange" hide-on-single-page :background="true">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
export default {
  created() {
    this.pstApi.setWindowTitle("添加留言系统管理员");
    this.getEmployes();
  },
  data() {
    return {
      data: {
        emps: [],
      },
      //搜索栏数据
      query: {
        name: "", //模糊字段
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
    };
  },
  methods: {
    //判断勾选
    selectable(row, index) {
      if (row.isManager) {
        return false;
      } else {
        return true;
      }
    },
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getEmployes();
    },
    formReturn() {
      this.$router.push("Supers");
    },
    queryEmps() {
      this.xpagination.pageNumber = 1;
      this.getEmployes();
    },
    getEmployes() {
      let name = this.query.name;
      let pageIndex = this.xpagination.pageNumber;
      let pageSize = this.xpagination.pageSize;
      this.pstApi
        .getEmps(name, pageIndex, pageSize)
        .then((resp) => {
          //读取成功
          //console.log(resp.data);
          this.data.emps = resp.data;
          //字符串转json
          var pagin = JSON.parse(resp.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.currentPage = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch((error) => {
          var message = error.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }

          this.$toast(message);
        });
    },
    //添加新记录
    rolesSave() {
      var selections = this.$refs.EmpTable.selection;
      if (selections.length == 0) {
        this.$message.error("请选择角色用户");
        return false;
      }
      selections.forEach(async (el) => {
        let userId = el.id;
        await this.pstApi
          .createManager(userId)
          .then((res) => {
            this.$toast("添加成功");
            this.getEmployes();
          })
          .catch((error) => {
            var message = error.response.data.Message;
            if (message == null) {
              message = "服务器访问失败";
            }

            this.$toast(message);
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-input.is- .el-input__inner {
  color: #031944;
}

/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

//
.img-list {
  overflow: hidden;
  width: 100%;

  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }

    // 底部
    .img-li-b--bottom {
      margin-top: 10px;

      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }

    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }

    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);

      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }

    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }

    // 悬浮可见删除 or 放大按钮
    &:hover {

      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }

    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;

    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}

.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;

  .el-button {
    flex: 1;
  }
}
</style>